<template>
  <div id="order-history-detail-page" v-cloak>
    <VBlock class="order-history-detail">
      <Loading :isShow="isLoading" />
      <VBlock class="page-wrapper" :direction="Direction.column" :sort="Sort.left_center">
        <OrderDetailSummaryContainer :chatbot="true" />
        <OrderDetailProductsContainer :chatbot="true" />
        <OrderDetailPaymentContainer />
        <OrderDetailDeliveryContainer />
        <OrderDetailCustomerCenterContainer />
      </VBlock>
    </VBlock>
  </div>
</template>

<script>
import VBlock, {
  Direction,
  Sort
} from '@/presentationals/v2/components/layouts/molecules/VBlock/index'
import Loading from '@/presentationals/v2/components/containers/LoadingContainer/index'

import OrderDetailSummaryContainer from '@/presentationals/v2/components/containers/OrderDetailSummaryContainer/index'
import OrderDetailProductsContainer from '@/presentationals/v2/components/containers/OrderDetailProductsContainer/index'
import OrderDetailPaymentContainer from '@/presentationals/v2/components/containers/OrderDetailPaymentContainer/index'
import OrderDetailDeliveryContainer from '@/presentationals/v2/components/containers/OrderDetailDeliveryContainer/index'
import OrderDetailCustomerCenterContainer from '@/presentationals/v2/components/containers/OrderDetailCustomerCenterContainer/index'
import { Action, MoveType } from '../../../../../plugins/AppManager'

import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'OrderHistoryDetailPage',
  components: {
    OrderDetailCustomerCenterContainer,
    OrderDetailDeliveryContainer,
    OrderDetailPaymentContainer,
    OrderDetailProductsContainer,
    OrderDetailSummaryContainer,
    Loading,
    VBlock
  },
  data() {
    return {
      Direction,
      Sort,

      isLoading: true
    }
  },
  computed: {
    isSign() {
      return this.$store.getters.isSign
    },
    orderDetail() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail']
    },
    canDeleteOrder() {
      return this.orderDetail.canDelete({ isSignedUser: this.isSign })
    }
  },
  async created() {
    // TODO delete test url http://localhost:9002/presentationals/v2/my/order/history/11697?key=SjVYMlRkZWI0SDFtY0VnZmluQ2p1Ny9SSTNmWHNOTGhoV2FZNkZ2ZmdGYkgyWGdaSC9IL0J2WmdYNUh4bEpNeC9iL1YyOFVybHJzcDFhb3A0OEFBRWhDczdCMUxTQ0Q4L2dOSG5MSkE1bEJZWm5ROG5rTDBlVXNvZ0VLRlJpUEo3TFcrbFBOQmJlNzJWMjNsOC9nZWZJTi9oT2JqR3BPK25EaHhVYkpVR21Tb2wvaW1MOUxkQ0VMSE5KbkduZ09s%3D%3D
    // TODO check src/views/my/order/OrderHistoryDetail.vue:39

    const { orderId } = this.$route.params
    const { signed } = this.$route.query
    this.$store.commit('setSignedUser', signed === 'true')

    const {
      success,
      failed,
      message,
      result,
      code
    } = await this.$store.dispatch('myOrderHistoryDetailV2/loadOrderDetail', { orderId })

    const {
      baeminMemberId: memberId,
      baeminMemberNo: memberNo,
      sessionId,
      deviceId,
      appVersion
    } = this.$store.getters

    this.$appLogManager.init({
      memberId,
      memberNo,
      sessionId,
      deviceId,
      appVersion
    })

    const { shopId, status } = this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary
    const { reservation } = this.$store.getters[
      'myOrderHistoryDetailV2/orderDetail'
    ].orderReservation

    const params = {
      OrdNo: String(orderId),
      OrdStatus: status,
      Reservation: reservation,
      ShopNo: String(shopId)
    }

    // M5
    this.$appLogManager.post({
      screenName: LogScreenName.MARKET_ORD_DET,
      type: LogType.VIEW,
      params
    })

    this.isLoading = false

    if (code === '401') {
      this.$store.dispatch('modal/open', {
        type: 'Check',
        message,
        onOK: async () => {
          this.$appManager.action(Action.REFRESH_TOKEN)

          if (this.$store.getters.isAndroid) {
            this.$appManager.action(Action.CLOSE)
            return
          }

          setTimeout(() => {
            this.$appManager.action(Action.CLOSE)
          }, 150)
        },
        onCancel: async () => {}
      })

      return
    }

    if (failed) {
      this.$store.dispatch('modal/open', {
        type: 'Check',
        message,
        onOK: async () => {
          this.$appManager.action(Action.CLOSE)
        },
        onCancel: async () => {}
      })
    }

    if (success && result.summary.deleted) {
      this.$store.dispatch('modal/open', {
        type: 'Check',
        message: '이미 삭제된 주문입니다.',
        onOK: async () => {
          this.$appManager.action(Action.CLOSE)
        },
        onCancel: async () => {}
      })
    }

    await this.$store.dispatch('myOrderHistoryDetailV2/loadCashReceipt', result.payment.paymentKey)
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

#order-history-detail-page {
  background-color: $background-gray;

  .order-history-detail {
    .page-wrapper {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
}
</style>
